import { gql } from '@apollo/client';

export const UPDATE_PICKUP_ROUTE = gql`
  mutation UpdatePickupRoute($input: UpdatePickupRouteInput!) {
    updatePickupRoute(input: $input) {
      id
      routeName
      warehouseId
      zipcodesListJson
      driverId
      vehicleId
      createdAt
      updatedAt
      isDeleted
    }
  }
`;
